import styled from 'styled-components'
import ImageZoom from 'react-image-zooom'

export const ImageZoomContainer = styled(ImageZoom)`
	width: 100% !important;
`
